import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { renderToStaticMarkup } from 'react-dom/server'
import ordersSelector from '../../../selectors/ordersSelector'
import { PulseLoader } from 'halogen'
import OrdersList from './OrdersList'
import { Well, ButtonToolbar } from '@sketchpixy/rubix'
import Dialog from 'material-ui/Dialog'
import OrderTable from './OrderTable'
import TicketOrder from '../events/TicketOrder'
import { NotificationManager } from 'react-notifications'
import * as MabnaButton from '../Button/Button'
import {
  FETCH_BUY_ORDERS_REQUEST,
  FETCH_USER_PROFILE,
  REQUEST_PAYMENT_REQUEST,
  CANCEL_PENDING_ORDER_REQUEST
} from '../../../actions/actions'
import {
  getErrors,
  flattenArray,
  appendToFormData,
  createFormFromObject
} from '../../../helpers/utility'

const styles = {
  spinner: {
    display: 'flex',
    height: '80vh',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center'
  }
}

const Message = ({ children }) => <div className="form-error">{children}</div>

class Index extends Component {
  constructor(props) {
    super(props)

    const initialState = {
      showPaymentModal: false,
      orderToShow: null,
      isAboutToRedirectToBank: false
    }

    this.initialState = initialState
    this.state = initialState
  }

  componentWillMount = () => {
    this.fetchUserOrders()
  }

  fetchUserOrders = () => {
    this.props.dispatch({ type: FETCH_BUY_ORDERS_REQUEST })
  }

  getOrderByRow = row => {
    const orderId = this.props.buyOrdersResult[row]
    const order = this.props.buyOrders[orderId]

    return order
  }

  isOrderRowPending = row => {
    const order = this.getOrderByRow(row)
    return order.order_status === 'pending'
  }

  handleClickOnPendingOrder = (row, column) => {
    if (column === 0) {
      this.setState(
        {
          orderToShow: this.getOrderByRow(row)
        },
        () => this.handleOrderCancel()
      )

      return
    }

    if (column === 1) {
      this.setState(
        {
          orderToShow: this.getOrderByRow(row)
        },
        () => this.handlePayment()
      )
      return
    }

    this.setState({ showPaymentModal: true, orderToShow: this.getOrderByRow(row) })
  }

  isOrderEvent = order =>
    order && order.service && order.service.type && order.service.type === 'event'

  handleClickOnCompletedOrder = (row, column) => {
    const order = this.getOrderByRow(row)

    if (column === 0) {
      // if (this.isOrderEvent(order)) {
        // this.printEventTicketOrder(order)
        // this.redirectUserToEventPage(order)
      // }
      if ( order.vitrin_link ) {
        browserHistory.push(`/ext-redirect${order.vitrin_link}`)
      }
    }

  }

  redirectUserToEventPage = order => {
    browserHistory.push(`/dashboard/events?payment-success=${order.id}`)
  }

  redirectToPaymentOptions = orderId => {
    browserHistory.push(`/dashboard/orders/${orderId}/payment-options`)
  }

  printTicketOrder = markup => {
    let openWindow = window.open('', 'برگه ورود به جلسه')
    openWindow.document.write(markup)
    openWindow.document.close()
    openWindow.focus()
    openWindow.print()
    openWindow.close()
  }

  handleClickOnListItem = (row, column) => {
    if (this.isOrderRowPending(row)) {
      this.handleClickOnPendingOrder(row, column)
    } else {
      this.handleClickOnCompletedOrder(row, column)
    }
  }

  closeModal = () => {
    this.setState({
      orderToShow: null,
      showPaymentModal: false
    })
  }

  handlePayment = () => {
    const { id } = this.state.orderToShow

    this.redirectToPaymentOptions(id)

    // this.requestPaymentInfo(order_code)
    //   .then(paymentInfo => {
    //     NotificationManager.info('در حال انجام درخواست', null, 6000)
    //     this.setState({ isAboutToRedirectToBank: true })
    //     this.redirectUserToPaymentPage(paymentInfo)
    //   })
    //   .catch(errors => {
    //     this.setState(this.initialState)
    //     this.notifyUserWithErrors(errors)
    //   })
  }

  requestPaymentInfo = order_code => {
    this.setState({ isAboutToRedirectToBank: true })

    const formData = appendToFormData({ order_code })

    return new Promise((resolve, reject) => {
      this.props.dispatch({
        type: REQUEST_PAYMENT_REQUEST,
        formData,
        resolve,
        reject
      })
    })
  }

  requestOrderCancel = orderId =>
    new Promise((resolve, reject) => {
      this.props.dispatch({
        type: CANCEL_PENDING_ORDER_REQUEST,
        orderId,
        resolve,
        reject
      })
    })

  handleOrderCancel = () => {
    const { id } = this.state.orderToShow

    this.requestOrderCancel(id)
      .then(res => {
        NotificationManager.success('سفارش با موفقیت لغو شد', null, 6000)
        this.setState(this.initialState)
        this.fetchUserOrders()
        this.triggerProfileUpdate()
      })
      .catch(errors => {
        this.setState(this.initialState)
        this.notifyUserWithErrors(errors)
      })
  }

  pendingOrdersMessage = 'کاربر گرامی، شما برای پرداخت سفارش‌های که نهایی نشده اند تنها یک ساعت زمان خواهید داشت، و پس از یک ساعت سفارش بطور خودکار لغو خواهد شد.'

  redirectUserToPaymentPage = paymentInfo => {
    window.location.href = paymentInfo.url
  }

  printEventTicketOrder(order) {
    this.printTicketOrder(
      renderToStaticMarkup(
        <TicketOrder
          {...order.service}
          ticket_orderOwners={order.owners}
          order_code={order.order_code}
          order_type={order.order_type}
          viewImage={false}
        />
      )
    )
  }

  notifyUserWithErrors({ form_errors, general_errors }) {
    const flattenedErrors = [
      ...flattenArray(general_errors),
      ...getErrors(form_errors)
    ]

    for (let error of flattenedErrors) {
      NotificationManager.error(error, null, 6000)
    }
  }

  triggerProfileUpdate = () => {
    this.props.dispatch({
      type: FETCH_USER_PROFILE,
      userType: this.props.userType,
      userId: this.props.userId
    })
  }

  render() {
    if (this.props.buyOrdersAsyncCall) {
      return (
        <div style={styles.spinner}>
          <PulseLoader color={'#00abde'} />
        </div>
      )
    } else {
      const orderModalActions = [
        <MabnaButton.Primary onClick={this.handlePayment}>
          {this.state.isAboutToRedirectToBank ? 'در حال اتصال به بانک' : 'پرداخت'}
        </MabnaButton.Primary>,
        <MabnaButton.Primary outlined onClick={this.handleOrderCancel}>
          لغو سفارش
        </MabnaButton.Primary>,
        <MabnaButton.Primary
          outline
          onClick={this.closeModal}
          className="floating-close-button"
        >
          بستن
        </MabnaButton.Primary>
      ]

      const { buyOrders, buyOrdersResult } = this.props

      return (
        <div>
          <Well>
            <ButtonToolbar>
              <span>
                <span>سفارش‌های شما</span>
              </span>
            </ButtonToolbar>
          </Well>

          <Message>{this.pendingOrdersMessage}</Message>

          {buyOrdersResult.length === 0 ? (
            <div style={{ fontSize: 18, textAlign: 'center' }}>
              در حال حاضر شما سفارشی ندارید
            </div>
          ) : (
            <OrdersList
              result={buyOrdersResult}
              orders={buyOrders}
              onCellClick={this.handleClickOnListItem}
            />
          )}

          <Dialog
            title="اطلاعات سفارش"
            actions={orderModalActions}
            modal={false}
            autoScrollBodyContent
            actionsContainerClassName="modal-actions"
            open={this.state.showPaymentModal}
            onRequestClose={this.closeModal}
            contentClassName="fatemi-modal"
          >
            <OrderTable data={this.state.orderToShow} />
          </Dialog>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
  ...ordersSelector(state),
  userType: state.auth.userType,
  userId: state.auth.userId
})

export default connect(mapStateToProps)(Index)



// WEBPACK FOOTER //
// ./src/components/common/orders/Index.js